import type { BannerDto } from '../application/dto/BannerDto';
import './BannerSection.css';

export interface BannerSectionProps {
  banner: BannerDto | null;
}

/**
 * Renders nothing when there is no active banner — an admin who hasn't
 * configured one yet, or has toggled it off, should get exactly the
 * pre-banner homepage layout back, not an empty gap or a broken image.
 */
export function BannerSection({ banner }: BannerSectionProps) {
  if (!banner || !banner.imageUrl) {
    return null;
  }

  return (
    <div className="dma-banner-section">
      <img src={banner.imageUrl} alt={banner.altText} className="dma-banner-section__image" />
    </div>
  );
}
